import React, { forwardRef } from 'react';

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  helperText?: string;
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}, ref) => {
  const radioId = id || `${props.name}_${props.value}` || Math.random().toString(36).substr(2, 9);
  
  const baseClasses = 'h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 transition-colors';
  const radioClasses = `${baseClasses} ${className}`.trim();

  return (
    <div className="w-full">
      <div className="flex items-center space-x-3">
        <input
          ref={ref}
          id={radioId}
          type="radio"
          className={radioClasses}
          {...props}
        />
        {label && (
          <label htmlFor={radioId} className="text-sm font-medium text-gray-700">
            {label}
          </label>
        )}
      </div>
      
      {(error || helperText) && (
        <div className="mt-1">
          {error && (
            <p className="text-red-500 text-xs">{error}</p>
          )}
          {!error && helperText && (
            <p className="text-gray-500 text-xs">{helperText}</p>
          )}
        </div>
      )}
    </div>
  );
});

Radio.displayName = 'Radio';

export default Radio;